<template>
  <!-- URL IMG -->
  <div class="md-layout-item md-size-100">
    <div style="margin-bottom: 15px;margin-top: -15px;">
      <md-button @click="addNewKeyUrl" class="md-primary md-info">
        {{$I18n("add")}} Key
      </md-button>
      <md-button @click="api_subKeyUrl" class="md-primary md-success" style="margin-left: 15px;">
        {{$I18n("save")}}
      </md-button>
    </div>
    <div class="md-layout">
      <div class="md-layout-item md-size-100"
        v-for="(item,main_index) in imgUrlList" 
        :key="item.id ? item.id :'index_' + main_index" 
        style="padding:0;margin-top:-30px;"
      >
        <md-card>
          <!-- 主要部分 INPUT -->
          <md-card-header class="md-card-header-icon md-card-header-blue">
            <h4 class="title" style="display: flex;padding-left: 20px; padding-bottom:10px; border-bottom: 2px solid #cccccc;">
              <!-- KEY -->
              <div style="width:10vw; max-width: 300px;margin-top:2px;margin-right: 20px;">
                <md-field>
                  <label>{{ "Key" }}<i style="color: red;">*</i></label>
                  <md-input v-model="item.key"/>
                </md-field>
              </div>
              <!-- 状态 -->
              <div style="width:10vw; max-width: 300px;">
                <md-field>
                  <label>{{ $I18n("state") }}</label>
                  <md-select v-model="item.state">
                    <md-option :value="1">{{$I18n('open')}}</md-option>
                    <md-option :value="2">{{$I18n('close')}}</md-option>
                  </md-select>
                </md-field>
              </div>
              <!-- 添加新的 urls -->
              <div style="display:inline-block; margin-top: 6px;margin-left: 15px" >
                <md-button @click="() => addNewUrl(main_index)" class="md-primary md-info md-just-icon md-round">
                  <md-icon>add</md-icon>
                </md-button>
              </div>
            </h4>
          </md-card-header>
          <!-- URL INPUT -->
          <md-card-content>
            <div v-if="item.urls && item.urls.length > 0" class="md-layout">
              <div v-for="(url,index) in item.urls" :key="'url_'+index" class="md-layout-item md-size-25 md-small-size-33" style="position: relative;"> 
                <div @click="() => removeUrls(main_index, index)" style="z-index: 10; padding: 3px; font-size: 13px; background: #777777; position: absolute; border-radius: 5px; right: 23px; top:6px; opacity: 0.3;cursor: pointer;">
                  <md-icon style="color: #ffffff;">delete</md-icon>
                </div>
                <div style="border: 2px solid #bbbbbb;width: 100%;min-height: 100px;border-radius: 8px;">
                  <!-- 图片显示 -->
                  <div style="margin: 4px; text-align: center; display: flex;padding-bottom: 4px ; border-bottom: 1px solid #bbbbbb; height:100px;    align-items: flex-start; position: relative;">
                    <img :src="url.url" @error="() => imgerror()" style="margin:auto; max-width:100%;max-height: 100px; width:auto; height: auto;"/>
                    <!-- <md-button class="m"></md-button> -->
                  </div>
                  
                  <!-- IMG URL 输入 -->
                  <div style="margin-top: 10px; padding: 0 10px 10px;" class="md-layout">
                    <div class="md-layout-item md-size-100">
                      <md-field>
                        <label>{{ "URL" }}</label>
                        <md-input v-model="url.url"/>
                      </md-field>
                    </div>
                  </div>
                  <div style="margin-top: 10px; padding: 0 10px;" class="md-layout">
                    <!-- 类型选择 -->
                    <div style="transition: none;" class="md-layout-item md-small-size-100" :class="{'md-size-50':url.lang !== 'other', 'md-size-33': url.lang === 'other',}">
                      <md-field>
                        <label>{{ "类型" }}</label>
                        <md-select v-model="url.type">
                          <md-option :value="1">{{$I18n('show_this')}}</md-option>
                          <md-option :value="2">{{$I18n('return_to')}}</md-option>
                        </md-select>
                      </md-field>
                    </div>
                    <!-- 语言选择 -->
                    <div style="transition: none;" class="md-layout-item md-small-size-100" :class="{'md-size-50':url.lang !== 'other', 'md-size-33': url.lang === 'other',}">
                      <md-field>
                        <label>{{ "语言" }}</label>
                        <md-select v-model="url.lang">
                          <md-option value="en">{{$I18n('en')}}</md-option>
                          <md-option value="zh-CN">{{$I18n('zh-CN')}}</md-option>
                          <md-option value="other">{{$I18n('other_lang')}}</md-option>
                        </md-select>
                      </md-field>
                    </div>
                    <!-- 其他语言时单独输入 -->
                    <div style="transition: none;" class="md-layout-item md-small-size-100" :class="{'md-size-0':url.lang !== 'other', 'md-size-33': url.lang === 'other',}">
                      <md-field>
                        <label>{{ "语言" }}</label>
                        <md-input v-model="url.other_lang"/>
                      </md-field>
                    </div>
                  </div>
                  <!-- Param -->
                  <div style="margin-top: 10px; padding: 0 10px 10px;" class="md-layout">
                    <div class="md-layout-item md-size-100">
                      <md-field>
                        <label>{{ $I18n("param") }}</label>
                        <md-input v-model="url.param"/>
                      </md-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
const simpleLang = ["en", "zh-CN"];
export default {
  props: {
    app_id : {
      type: String,
      default: "",
    },
  },
  data(){
    return {
      imgUrlList:[],
    }
  },
  created(){
    this.api_getUrl();
  },
  watch:{
    app_id() {
      this.api_getUrl();
    },
  },
  methods:{
    addNewKeyUrl(){
      this.imgUrlList = [{
        master_id: this.app_id,
        state: 1,
        key: "",
        urls: [{
          url: "",
          type: 1,
          lang: "en",
          other_lang: "",
        }],
      } ,...this.imgUrlList];
    },
    api_subKeyUrl(){
      const updateList = this.imgUrlList.filter(item => item.key);
      if(updateList.length === 0){
        this.$errorMsg(this.$I18n("none_submit"));
        return
      }
      updateList.forEach(item => {

        this.$api[item.id ?"setAppImgUrl" :"addAppImgUrl"]({
          ...item,
          master_id: this.app_id,
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("edit_success"));
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
      });
    },
    removeUrls(mainIndex, removeIndex){
      this.imgUrlList = this.imgUrlList.map((i, main) => {
        if(mainIndex != main){
          return {...i}
        }
        return {
          ...i,
          urls: [...i.urls.filter((_, index) => index !== removeIndex)],
        };
      })
      console.log(this.imgUrlList)
      console.log(mainIndex, removeIndex);
    },
    api_getUrl(){
      return this.$api.getAppImgUrl({ // api: /user/app/img/get
        master_id: this.app_id,
      })
        .then(this.$Then(res => {
          this.imgUrlList = res.data.map(item => {
            return {
              ...item,
              urls: item.urls.map(url => {
                return {
                  ...url,
                  lang : simpleLang.includes(url.lang) ?url.lang :"other",
                  other_lang: simpleLang.includes(url.lang) ?"" :url.lang,
                }
              })
            }
          });
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    addNewUrl(index){
      this.imgUrlList[index].urls = [{
        url: "",
        type: 1,
        lang: "en",
        param: "",
        other_lang: "",
      }, ...this.imgUrlList[index].urls];
    },
    imgerror(e){
      console.log(e)
    },
  },
}
</script>